import { createFileRoute, notFound, redirect, useRouter } from "@tanstack/react-router";
import { YearPage } from "@/components/pages/YearPage";
import { SiteShell } from "@/components/layout/SiteShell";
import { parseYearSlug, parseMonthSlug, parseDateSlug, MONTH_SLUGS_ID } from "@/lib/calendar/dates";
import { withSlash } from "@/lib/url";

export const Route = createFileRoute("/kalender/$year/")({
  loader: ({ params }) => {
    const y = parseYearSlug(params.year);
    if (y === null) {
      // Legacy flat slugs: /kalender/juni-2026 → /kalender/2026/juni/
      const ym = parseMonthSlug(params.year);
      if (ym) {
        throw redirect({ to: `/kalender/${ym.y}/${MONTH_SLUGS_ID[ym.m - 1]}/`, code: 308 } as any);
      }
      const ymd = parseDateSlug(params.year);
      if (ymd) {
        throw redirect({ to: `/kalender/${ymd.y}/${ymd.d}-${MONTH_SLUGS_ID[ymd.m - 1]}/`, code: 308 } as any);
      }
      throw notFound();
    }
    return { y };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return {};
    const title = `Kalender ${loaderData.y} Lengkap - Tanggal Merah & Cuti Bersama`;
    const desc = `Kalender Indonesia ${loaderData.y} lengkap dengan libur nasional, cuti bersama, Hijriah, Jawa, dan Bali.`;
    const canonical = `https://hari.co.id${withSlash(`/kalender/${params.year}`)}`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: canonical },
        { property: "og:locale", content: "id_ID" },
        { property: "og:locale:alternate", content: "en_US" },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  component: KalenderYear,
  notFoundComponent: () => (
    <SiteShell>
      <div className="py-16 text-center">
        <h1 className="text-2xl font-bold">Halaman tidak ditemukan</h1>
      </div>
    </SiteShell>
  ),
  errorComponent: ({ error, reset }) => {
    const router = useRouter();
    return (
      <SiteShell>
        <div className="py-16 text-center">
          <h1 className="text-2xl font-bold">Terjadi kesalahan</h1>
          <p className="mt-2 text-sm text-muted-foreground">{error.message}</p>
          <button onClick={() => { router.invalidate(); reset(); }} className="mt-4 rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground">
            Coba lagi
          </button>
        </div>
      </SiteShell>
    );
  },
});

function KalenderYear() {
  const { y } = Route.useLoaderData();
  return <YearPage y={y} />;
}